import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyBMw8jtdYpZXBlwFkT5hgxG7zk-3PKV91o",
  authDomain: "chatapp-7bb70.firebaseapp.com",
  projectId: "chatapp-7bb70",
  storageBucket: "chatapp-7bb70.appspot.com",
  messagingSenderId: "566991174389",
  appId: "1:566991174389:web:3100ec02755c2687f2e3bc",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
